import React from "react";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

export const NumberFormatter = (value = 0) => {
  const formatted = new Intl.NumberFormat("en-IN").format(value);

  return <span>{formatted}</span>;
};

export function Capitalize(str) {
  var newStr = str?.toLowerCase();
  if (newStr) {
    return newStr.charAt(0).toUpperCase() + newStr.slice(1);
  } else {
    return str;
  }
}

const preprocessData = (data) => {
  const removeKeys = [
    "__v",
    "pins",
    "updatedAt",
    "otp",
    "expiredAt",
    "venueName",
    "fair",
    "checkInDate",
    "passingYear",
    "parentName",
    "parentCountryCode",
    "parentPhone",
  ];

  const columnsOrder = [
    "_id",
    "name",
    "description",
    "name",
    "code",
    "phone",
    "status",
    "fairCode",
    "venue",
    "address",
    "directionLink",
    "attendee",
    "location",
    "intakeYear",
    "notes",
    // "parentName",
    // "parentCountryCode",
    // "parentPhone",
  ];

  return data.map((item) => {
    // Remove unwanted keys
    const newItem = Object.keys(item)
      .filter((key) => !removeKeys.includes(key))
      .reduce((obj, key) => {
        obj[key] = item[key];
        return obj;
      }, {});

    for (const key in newItem) {
      if (typeof newItem[key] === "boolean") {
        newItem[key] = newItem[key] ? "Yes" : "No";
      }
      if (Array.isArray(newItem[key])) {
        // Check if array contains objects
        const isArrayOfObjects = newItem[key].every(
          (el) => el && typeof el === "object" && !Array.isArray(el)
        );

        if (isArrayOfObjects) {
          newItem[key] = newItem[key]
            .map((obj) => obj?.name || obj?.company || obj?.degree || JSON.stringify(obj))
            .join(", ");
        } else {
          newItem[key] = newItem[key].join(", ");
        }
      }

      // Handle plain objects
      if (newItem[key] && typeof newItem[key] === "object" && !Array.isArray(newItem[key])) {
        // If it has a "name" property, use that, otherwise stringify
        if (key == "checkIn") {
          newItem["intakeYear"] = newItem[key]?.intakeYear;
          newItem["country"] = newItem[key]?.country || newItem["country"];
          newItem["graduation"] = newItem[key]?.graduation || newItem["graduation"];
          // newItem["parentName"] = newItem[key].parentName;
          // newItem["parentCountryCode"] = newItem[key].parentCountryCode;
          // newItem["parentPhone"] = newItem[key].parentPhone;
          newItem["mainEntry"] = "yes";
        } else if (key == "attendee") {
          newItem["intakeYear"] = newItem[key].checkIn?.intakeYear;
          newItem["country"] = newItem[key].checkIn?.country;
          newItem["graduation"] = newItem[key].checkIn?.graduation || newItem[key].graduation;
          // newItem["parentName"] = newItem[key].checkIn.parentName;
          // newItem["parentCountryCode"] = newItem[key].checkIn.parentCountryCode;
          // newItem["parentPhone"] = newItem[key].checkIn.parentPhone;
          newItem["counselled"] = newItem[key].counselled ? "Yes" : "No";
          newItem["code"] = newItem[key].code;
          newItem["phone"] = newItem[key].phone;
          newItem["attendee"] = newItem[key].name;
          // console.log("______newItem[key]____0___", newItem[key]);
        } else if (key == "user") {
          newItem["name"] = newItem[key].name;
          newItem["code"] = newItem[key].code;
          newItem["phone"] = newItem[key].phone;
        } else {
          if (key == "createdBy") {
            newItem["checkedInBy"] = newItem[key].name || JSON.stringify(newItem[key]);
          } else {
            newItem[key] = newItem[key].name || JSON.stringify(newItem[key]);
          }
        }

        // console.log("______newItem[key]_______", key);
      }
    }

    // 👇 Reorder keys based on columnsOrder
    const orderedItem = {};
    columnsOrder.forEach((col) => {
      if (newItem.hasOwnProperty(col)) {
        orderedItem[col] = newItem[col];
      }
    });

    // Add remaining keys not in columnsOrder (optional)
    Object.keys(newItem).forEach((key) => {
      if (key != "createdBy" && !orderedItem.hasOwnProperty(key)) {
        orderedItem[key] = newItem[key];
      }
    });

    return orderedItem;
  });
};

export const notify = (msg = "Success!") => toast.success(msg);

export const exportToExcel = (data, fileName = "data.xlsx") => {
  const processed = preprocessData(data);
  // 1. Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(processed);

  // 2. Create a workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // 3. Write the workbook to a binary buffer
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // 4. Create a Blob and trigger download
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

export const statusColors = {
  planned: "secondary",
  ongoing: "success",
  completed: "warning",
  cancelled: "closed",
};

export const fairStatus = {
  planned: "Planned",
  ongoing: "Ongoing",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const leadColors = {
  hot_lead: "primary",
  cold_lead: "info",
  warm_lead: "warning",
};

export const getFlagEmoji = (countryCode: string) => {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};
